// extracted by mini-css-extract-plugin
export default {"header":"Header_header__TCSgk","header_inner":"Header_header_inner__MTdJu","logo_container":"Header_logo_container__vIT8o","logo_title":"Header_logo_title__w2TKH"};